import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http'

export interface Group {
  id: number;
  name: string;
}

@Injectable({
  providedIn: 'root'
})
export class GroupsService {

  constructor(private http: HttpClient) { }

  GetAll() {
    return this.http.get<Group[]>(environment.api_url + 'api/v1.0/groups/')
  }
  
  GetGroupById(id: string) {
    return this.http.get<Group>(environment.api_url + '/api/v1.0/groups/' + id)
  }

  EditGroup(id: string, body) {
    return this.http.patch<Group>(environment.api_url + 'api/v1.0/groups/id/' + id, body)
  }

  AddGroup(body) {
    return this.http.post<Group>(environment.api_url + 'api/v1.0/groups/', body )
  }

  DeleteGroup(id: string) {
    return this.http.delete(environment.api_url + 'api/v1.0/groups/id/' + id);
  }
}
